module.exports={
    "over_size_message":"Bildet du lastet opp er over 10MB. Vi komprimerer filen din for opplasting. Klikk \"Bekreft\" for å fortsette opplastingen.",
    "file_type_error":"Filen du lastet opp er ikke et bilde! Prøv å laste opp igjen.",
    "upload_error":"Opplastingsfeil! (Feilkode: 2000) Prøv igjen.",
    "watermark_remove_over_size":"Bildet du lastet opp er over 5MB. Det anbefales at du bruker vår gratis online bildekompressor. Klikk for å <a class=\"jump-link\" href=\"https://www.anymp4.com/no/image-compressor-online/\">lære mer</a>",
    "watermark_remove_file_type_error":"Filen du lastet opp er ikke et bilde. Last opp igjen.",
    "watermark_remove_image_type_error":"Bildeformatet støttes ikke. Vi støtter kun JPG, JPEG, PNG og BMP.",
    "watermark_remove_upload_error":"Gjenkjennelsesfeil (feilkode: 2001), prøv igjen...",
    "watermark_remove_processing":"Behandler bilde...",
    "watermark_remove_not_save":"Området du valgte vil ikke bli beholdt. Er du sikker på at du vil beskjære den?",
    "watermark_remove_back_home":"Gjeldende status vil ikke bli lagret. Er du sikker på at du vil gå tilbake til Hjem?",
    "watermark_remove_new_image":"Gjeldende status vil ikke bli lagret. Er du sikker på at du vil velge et nytt bilde?",
    "watermark_select":"Plukke ut",
    "watermark_select_area":"Velg området for vannmerket du vil slette før du klikker Fjern.",
    "watermark_beyond_4k":"Det valgte bildet overskrider 4K oppløsning. Vi beklager at vi ikke kan behandle den for øyeblikket",
    "watermark_beyond_pixel_1":"Den valgte bildeoppløsningen overskrider <span>%spx</span><span>&times;%spx</span>. Den kan ikke behandles, velg på nytt.",
    "watermark_beyond_pixel_2":"Besøkende kan bare behandle <span>%s</span> bilder med oppløsning over <span>%spx</span>x<span>%spx</span>, vennligst logg på og fortsett å bruke.",
    "watermark_beyond_size_1":"Den valgte bildestørrelsen overskrider <span>%sMB</span>. Den kan ikke behandles, velg på nytt.",
    "watermark_beyond_size_2":"Den valgte bildestørrelsen overskrider <span>%sMB</span>, men besøkende kan bare behandle bilder mindre enn <span>%sMB</span>. Vennligst logg inn og fortsett å bruke.",
    "no_user_down":"Besøkende kan bare laste ned <span>%s</span> bilder med original kvalitet. Logg inn og fortsett nedlastingen. Du kan også beholde 7-dagers historikk etter pålogging. Fortsett å laste ned bilder som er <span>%spx</span> brede eller høye.",
    "no_down_rights":"Kan ikke laste ned HD-bilder med original kvalitet, oppgrader planen din! Du kan også fortsette å laste ned bilder av lav kvalitet med <span>%spx</span>.",
    "error_40001":"Feil: 40001. Ta kontakt med oss",
    "error_40099":"Feil: 40099. Ta kontakt med oss",
    "down_btn":"Nedlasting er under forberedelse, vennligst vent et øyeblikk...",
    "noRemove_down_btn":"Du har ikke gjort noe for å fjerne vannmerker. Velg vannmerket du vil fjerne, og klikk på Fjern-knappen. Deretter kan du laste ned bildet ditt.",
    "history_open":"Åpner det endrede bildet, vennligst vent et øyeblikk...",
    "maskRightsMonitor_info":"Siden for fordelsoppgradering har blitt åpnet i en ny fane, og planen din vil automatisk synkroniseres etter oppgradering.",
    "maskLoginMonitor_info":"Landingssiden har blitt åpnet, vennligst fullfør påloggingen på den. Etter å ha logget inn eller registrert vellykket, vil denne siden synkroniseres automatisk, vennligst ikke lukk den.",
    "photo_rights_info":"<span><i class=\"num\">2</i> HD-bilder</span> med original kvalitet kan lastes ned for øyeblikket. <a href=\"https://account.anymp4.com\" target=\"_blank\">Se detaljer>></a>",
    "rights_original":"For å slå på \"Bruk Image Enhancer-funksjonen for å redusere kvalitetstapet\"-innstillingen, må du oppgradere kontoen din!",
    "Brush":"Børste",
    "Lasso":"Lasso",
    "Polygonal":"Polygonal",
    "Eraser":"Viskelær",
    "Free":"Gratis",
    "More":"Mer:",
    "Select":"Plukke ut",
    "Remove":"Ta vekk",
    "BrushSize":"Pensel størrelse:",
    "AspectRatio":"Størrelsesforholdet:",
    "Upload":"Nytt bilde",
    "History":"Historie",
    "Login":"Logg Inn",
    "MyAccount":"Min konto",
    "Logout":"Logg ut",
    "Usinghelp":"Bruke hjelp >>",
    "Enhancer":"Bruk Image Enhancer-funksjonen for å redusere kvalitetstapet",
    "Download":"Nedlasting",
    "Guide":"Guide",
    "Polygonal1":"Polygonal",
    "Polygonal_info":"Klikk med venstre museknapp for å identifisere et punkt om gangen.",
    "Lasso1":"Lasso:",
    "Lasso_info":"Trykk lenge på venstre museknapp for å lasso vannmerkeområdet.",
    "Brush1":"Børste:",
    "Brush_info":"Trykk lenge på venstre museknapp for å velge nøyaktig.",
    "Eraser1":"Viskelær:",
    "Eraser_info":"Slett unødvendige deler fra det valgte området.",
    "Click":"Klikk",
    "the":"de",
    "click_info":"for å begynne å utslette det uønskede vannmerket.",
    "PleaseUploadImages":"Last opp bilder.",
    "CropInfo":"Når vannmerket er fjernet, kan du klikke på Beskjær-knappen for å beskjære bildet før du lagrer det, eller klikk på Last ned-knappen for å lagre det gjeldende bildet direkte.",
    "Crop":"Avling",
    "Back":"Tilbake",
    "DownloadCropped":"Last ned beskjært",
    "Cancel":"Avbryt",
    "FreeWatermarkRemover":"Gratis vannmerkefjerner",
    "Processing":"Behandling...",
    "NewImage":"Nytt bilde",
    "Retry":"Prøv på nytt",
    "Yes":"Ja",
    "No":"Nei",
    "FailureFeedback":"Tilbakemelding om feil",
    "removeTip":"Etter å ha valgt vannmerkeområdet, klikk Fjern for å slette vannmerket.",
    "rightDown":"Last ned bilder av lav kvalitet",
    "history_will":"Vil utløpe etter",
    "Expired":"(Utløpt)",
	"uploadImage":"Last opp bilde",
    "uploadImageInfo":"Eller slipp bildefilen din her for å fjerne vannmerket!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain THREE HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Ubegrenset",
    "watermark_beyond_pixel_3":"Det valgte bildet overskrider <span>%s&times;%s oppløsning</span>. Oppgrader planen din først.",
    "watermark_beyond_size_3":"Det valgte bildet overskrider <span>%sMB</span>. Oppgrader planen din først.",
    "no_user_login":"Nye brukere som logger på kan få TO fordeler ved å laste ned originale HD-bilder.<span class=\"loginMaskbtn\">Logg på umiddelbart>></span>",
    "Upgrade":"Oppgradering",
    "Loading":"Laster inn …",
    "SelectAll":"Velg alle",
    "Open":"Åpen",
    "Delete":"Slett",
    "Clear":"Slett ugyldig",
    "noHistory":"Ingen historie",
    "Close":"Lukk",
    "buyUserInfo":"gratulerer! Du har oppgradert. Gå tilbake til hjemmesiden og bruk dette produktet.",
    "buyNoUserInfo":"Gratulerer! Du har oppgradert. Fordelene er bundet til e-postadressen du la igjen under oppgraderingen. Bruk kontoen som er registrert eller koblet til e-postadressen for å <span class=\"loginMaskbtn\">logge inn for å bruke fordelene</span>. Hvis du ikke har registrert eller koblet en konto til e-postadressen, vennligst <span class=\"registerMaskbtn\">bruk e-postadressen for å registrere en konto</span> eller koble andre kontoer til denne e- e-postadresse for bruk av fordeler.",
    "GetStarted":"Kom i gang",
    "AccessTo":"Tilgang til:",
    "imagesOfwatermarkremoval":"bilder av fjerning av vannmerke",
    "upTo":"Opp til",
    "perImage":"per bilde",
    "Support":"Brukerstøtte",
    "resolution":"Vedtak",
    "PrepaidPackage":"Forhåndsbetalt pakke",
    "PayasYouGo":"Betal mens du går",
    "TaxIncl":"Skatt inkl. mva.",
    "Checkout":"Sjekk ut",
    "imagesDay":"bilder/dag",
    "imagesMonthly":"bilder/månedlig",
    "image":"bilde",
    "images":"Bilder",
    "imageSize":"bildestørrelse",
    "buyInfo1":"Tredjeparts <span>enhancer</span>-integrasjoner",
    "buyInfo2":"Redigeringsloggen er gyldig i 7 dager",
    "buyInfo3":"Prioritert behandling",
    "buyInfo4":"7x24 kundestøtte",
    "buyInfo5":"Utløpt etter 24 timer",
    "buyInfo6":"Ingen abonnement. Ingen automatisk fornyelse!",
    "buyInfo7":"Tilgjengelig for bruk når som helst for alltid",
    "dayPlan":"1-dagers plan",
    "Lifetime":"Livstid",
    "note":"<span>Merk</span>: Vær oppmerksom på at den kjøpte planen er knyttet til e-postadressen som ble oppgitt under kassen. For å bruke planen vellykket, registrer deg eller logg på med den samme e-postadressen."
}